"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("./components/ReactSlider/ReactSlider.js");

exports.default = e.default;